export default __webpack_public_path__ + "static/media/jumia.67a61404.svg";